import { Body, Button, HeadlineSize, Modal } from '@postidigital/posti-components'
import { observer } from 'mobx-react-lite'
import React, { useCallback, useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'styled-components'

import { StoreContext } from '../../store'

interface IProps {
  businessId: string
  accountId: string
  userEmail: string
}

const RemoveUserModalComponent: React.FC<IProps> = ({ businessId, accountId, userEmail }) => {
  const [t] = useTranslation()
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const { userDetailsStore } = useContext(StoreContext)
  const theme = useTheme()

  const toggleModalOpen = useCallback(() => {
    setModalOpen((prevState) => !prevState)
  }, [])

  const handleDelete = useCallback(async () => {
    await userDetailsStore.removeOrganisation(businessId, accountId, userEmail)
    setModalOpen(false)
  }, [accountId, businessId, userDetailsStore, userEmail])

  return (
    <Modal isOpen={modalOpen}>
      <Modal.Dialog>
        <Modal.DialogHeadlineAligner>
          <Modal.DialogHeadline size={HeadlineSize.Six} style={{ padding: `${theme.spacing.space4}rem` }}>
            {t(`removeModal.title`)}
          </Modal.DialogHeadline>
        </Modal.DialogHeadlineAligner>
        <Modal.CloseButton type="button" aria-label="Close" onClick={toggleModalOpen} />
        <Modal.DialogContent>
          <Modal.DialogHero>
            <Body size="Three">{t(`removeModal.content`)}</Body>
            <Modal.DialogButtons>
              <Button id="delete_modal" contentMode="primary" onClick={handleDelete}>
                {t(`removeModal.removeButton`)}
              </Button>
              <Button contentMode="secondary" id="cancel_modal" onClick={toggleModalOpen}>
                {t(`general.cancel`)}
              </Button>
            </Modal.DialogButtons>
          </Modal.DialogHero>
        </Modal.DialogContent>
      </Modal.Dialog>
    </Modal>
  )
}

export const RemoveUserModal = observer(RemoveUserModalComponent)
